
const assert = require('assert');

const _ = require('lodash');

const ko = require('knockout');


function assertThisObservable (thisObservable) {
	assert(
		ko.isObservable(thisObservable),
		'`toJS` and `fromJS` must be called as a method (with `this` bound to an observable)'
	);
}


ko.extenders.toJS = function (target, params) {
	if (_.isFunction(params)) {
		const toJS = params;
		target.toJS = function () {
			assertThisObservable(this);
			return toJS(this);
		};
		return;
	}

	const enable = Boolean(params);

	if (enable) {
		target.toJS = function () {
			assertThisObservable(this);
			return ko.unwrap(this);
		};
	} else {
		delete target.toJS;
	}
};

ko.extenders.fromJS = function (target, params) {
	if (_.isFunction(params)) {
		const fromJS = params;
		target.fromJS = function (js) {
			assertThisObservable(this);
			return fromJS(js, this);
		};
		return;
	}

	const enable = Boolean(params);

	if (enable) {
		target.fromJS = function (js) {
			assertThisObservable(this);
			if (ko.isWritableObservable(this)) {
				this(js);
			}
		};
	} else {
		delete target.fromJS;
	}
};

ko.extenders.inheritToJS = function (target, parent) {
	target.toJS = parent.toJS;
};

ko.extenders.inheritFromJS = function (target, parent) {
	target.fromJS = parent.fromJS;
};

ko.extenders.inheritToFromJS = function (target, parent) {
	target.extend({
		inheritToJS: parent,
		inheritFromJS: parent,
	});
};

ko.extenders.toJSMap = function (target, mapToJS) {
	target.extend({
		toJS: (target) => mapToJS(ko.unwrap(target), target),
	});
};

ko.extenders.toJSResetIf = function (target, condition) {
	const superToJS = target.toJS;
	target.extend({
		toJS: (...args) => condition.call(target) ? null : superToJS.call(target, ...args),
	});
};

ko.extenders.fromJSMap = function (target, mapFromJS) {
	target.extend({
		fromJS: (js, target) => {
			if (ko.isWritableObservable(target)) {
				target(mapFromJS(js, target));
			}
		},
	});
};

ko.extenders.toFromJS = function (target, enable) {
	enable = Boolean(enable);
	target.extend({
		toJS: enable,
		fromJS: enable,
	});
};
